/** Address composition helpers: compose display strings from address parts, dropping empties. The inverse of `address-helpers.ts`, which decomposes a comma-delimited address into its parts. */

/** Join the truthy parts of a list with a separator, dropping falsy entries; non-string parts coerce via `Array.prototype.join`, exactly as the inline `parts.filter(Boolean).join(sep)` idiom does. */
export function compactJoin(parts: ReadonlyArray<unknown>, sep: string): string {
	return parts.filter(Boolean).join(sep);
}

/**
 * The locality line -- `City, ST` -- a property or transaction row shows beside its street line. Empty when both parts
 * are blank, so each caller applies its own fallback (a card subtitle, a hero overlay, a detail header).
 */
export function cityStateLine(row: { district_city?: unknown; state_province?: unknown }): string {
	return compactJoin([row.district_city, row.state_province], ', ');
}
